// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"4db1f87d","198":"47c84791","453":"c0d42d88"}[chunkId] + ".chunk.js";
};